import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { BoardSuggestion } from "~/components/SearchBar/Suggestion/BoardSuggestion";
import { SavedFilterSuggestion } from "~/components/SearchBar/Suggestion/SavedFilterSuggestion";
import { SuggestionsSectionHeader } from "~/components/SearchBar/Suggestion/SuggestionsSectionHeader";
import { TextSuggestion } from "~/components/SearchBar/Suggestion/TextSuggestion";
export const AssetsSearchSuggestions = /*#__PURE__*/ memo((param)=>{
    let { textSuggestions = [], boardSuggestions = [], onBoardClick, onTextClick, boardsSectionTitle, savedFiltersSectionTitle, savedFilterSuggestions = [], onSavedFilterClick } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            textSuggestions.map((text, index)=>/*#__PURE__*/ _jsx(TextSuggestion, {
                    index: index,
                    value: text,
                    onClick: onTextClick
                }, "".concat(text).concat(index))),
            !!(savedFilterSuggestions === null || savedFilterSuggestions === void 0 ? void 0 : savedFilterSuggestions.length) && /*#__PURE__*/ _jsx(SuggestionsSectionHeader, {
                className: textSuggestions.length ? "mt-6" : "mt-2",
                children: savedFiltersSectionTitle
            }),
            savedFilterSuggestions === null || savedFilterSuggestions === void 0 ? void 0 : savedFilterSuggestions.map((board, index)=>/*#__PURE__*/ _jsx(SavedFilterSuggestion, {
                    savedFilter: board,
                    onClick: onSavedFilterClick,
                    index: index + textSuggestions.length
                }, board.id)),
            !!boardSuggestions.length && /*#__PURE__*/ _jsx(SuggestionsSectionHeader, {
                className: savedFilterSuggestions.length ? "mt-6" : "mt-2",
                children: boardsSectionTitle
            }),
            boardSuggestions === null || boardSuggestions === void 0 ? void 0 : boardSuggestions.map((board, index)=>/*#__PURE__*/ _jsx(BoardSuggestion, {
                    board: board,
                    onClick: onBoardClick,
                    index: index + textSuggestions.length + savedFilterSuggestions.length
                }, board.id))
        ]
    });
});
AssetsSearchSuggestions.displayName = "AssetsSearchSuggestions";
